((global) => {
  if (global.NSPlisseePhotos) return;
  const requests = new Map();
  const normalize = (value) => String(value || '').normalize('NFC').trim().toLocaleLowerCase('de');
  const key = (fabric, profile, structure) => [normalize(fabric), normalize(profile), structure === 'honeycomb' ? 'honeycomb' : 'pleated'].join('|');
  const createIndex = (catalog) => {
    if (catalog?.version !== 1 || !Array.isArray(catalog.images)) return null;
    const images = new Map();
    catalog.images.forEach((entry) => {
      if (!entry.fabric || !entry.profile || !['pleated', 'honeycomb'].includes(entry.structure) || typeof entry.url !== 'string') return;
      let url;
      try { url = new URL(entry.url, global.location.origin); } catch { return; }
      if (url.protocol !== 'https:') return;
      const imageKey = key(entry.fabric, entry.profile, entry.structure);
      images.set(imageKey, Object.assign({}, entry, {key: imageKey, url: url.href}));
    });
    return {size: images.size, get: (fabric, profile, structure) => images.get(key(fabric, profile, structure)) || null};
  };
  const load = (url) => {
    if (!url) return Promise.resolve(null);
    if (!requests.has(url)) {
      requests.set(url, fetch(url, {credentials: 'omit', headers: {Accept: 'application/json'}})
        .then((response) => response.ok ? response.json() : null).then(createIndex).catch(() => null));
    }
    return requests.get(url);
  };
  const resized = (source, width) => {
    const url = new URL(source);
    url.searchParams.set('width', String(width));
    return url.href;
  };
  const setImage = (image, entry, thumbnail = false) => {
    if (!image || !entry) return;
    const width = Number.isSafeInteger(entry.width) && entry.width > 0 ? entry.width : 1254;
    const height = Number.isSafeInteger(entry.height) && entry.height > 0 ? entry.height : width;
    const widths = thumbnail ? [160, 320] : [480, 720, 960, 1254];
    image.width = width;
    image.height = height;
    image.alt = entry.alt || [entry.fabric, entry.profile, entry.structure === 'honeycomb' ? 'Wabenplissee' : 'Plissee'].join(', ');
    image.loading = thumbnail ? 'lazy' : 'eager';
    image.decoding = 'async';
    image.fetchPriority = thumbnail ? 'auto' : 'high';
    image.sizes = thumbnail ? '80px' : '(min-width:1024px) 50vw, 100vw';
    image.srcset = widths.map((size) => resized(entry.url, size) + ' ' + size + 'w').join(', ');
    image.src = thumbnail ? resized(entry.url, 160) : entry.url;
    image.dataset.nsPhotoKey = entry.key || key(entry.fabric, entry.profile, entry.structure);
  };
  global.NSPlisseePhotos = {createIndex, key, load, setImage};
})(window);
